import styled from 'styled-components'
import { Box, Button } from '@usap/uicomponents'

export const ProceedToCheckoutSection = styled(Box)`
  width: 100%;
  min-height: 40px;

  .cart__proceed-to-checkout--wrapper {
    width: 100%;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  @media screen and (max-width: 992px) {
    .cart__proceed-to-checkout--wrapper {
      width: 100%;
      top: auto;
      left: 0;
      bottom: 0;
      position: fixed;
      box-shadow: 0 0 4px 0 #CCCACA;
      z-index: 5;
      background: #ffffff;
      padding: 12px;
    }
  }
`

export const ProceedToCheckoutButton = styled('button')`
  color: #282832;
  text-align: center;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  border: none;
  border-radius: 4px;
  background: #FFCD05;
  height: 40px;

  &:hover:not([disabled]) {
    border: none;
    background: #ffff52;
    color: #000;
  }
 
  &:hover[disabled] {
    border: none;
    background: #ffce05;
    color: #000;
  }
`
